import { FC, ReactNode } from "react";
import { Avatar, Flex } from "@chakra-ui/react";
import AvatarSource from "~/images/lauren-profile.jpg";
import { CopyContainer } from "./CopyContainer";

interface Props {
  children: ReactNode;
  color: string;
}

export const CommentStatic: FC<Props> = ({ children, ...props }) => {
  return (
    <Flex
      border="1px solid"
      borderColor="th.cream3"
      borderRadius="lg"
      boxShadow="0px 4px 4px 0px rgba(0, 0, 0, 0.05)"
      direction="column"
      gap={2}
      p={4}
      w="full"
      align="flex-end"
    >
      <CopyContainer {...props}>{children}</CopyContainer>
      <Avatar height="3rem" src={AvatarSource} width="3rem" />
    </Flex>
  );
};
